module.exports = __webpack_public_path__ + "img/close.3c0dc078.svg";